import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Auth} from '../actions/auth.actions';
import {LoggingService} from '../services/logging.service';
import {Logging} from '../actions/logging.actions';
import ClearState = Auth.ClearState;
import GetLogs = Logging.GetLogs;
import {TransactionLog} from '../models/logging/transactionLog.model';
import {GetLogsResponse} from '../models/logging/getLogs.response';

export interface LoggingStateModel {
  logs: TransactionLog[];
  size: number;
}

@State<LoggingStateModel>({
  name: 'logging',
  defaults: {
    logs: [],
    size: 0
  }
})
@Injectable()
export class LoggingState {
  constructor(private loggingService: LoggingService
  ) {
  }

  @Selector()
  static logs(state: LoggingStateModel): TransactionLog[] {
    return state.logs;
  }

  @Selector()
  static size(state: LoggingStateModel): number {
    return state.size;
  }

  @Action(GetLogs)
  getLogs(ctx: StateContext<LoggingStateModel>, action: GetLogs): Observable<GetLogsResponse> {
    return this.loggingService.getLogs(action.request).pipe(
      tap(res => {
        ctx.patchState({
          logs: res.logs,
          size: res.size
        });
      })
    );
  }

  @Action(ClearState)
  clearState(ctx: StateContext<LoggingStateModel>): void {
    ctx.setState({
      logs: [],
      size: 0
    });
  }
}
